import type { IconSvgObject } from './types';

const AppleNewsIcon: IconSvgObject = [
  ["path", { d: "M14 3H21.0016V10L14 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 21H2.99941V14L10 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 21L21 15L9 3H3V9L15 21H21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AppleNewsIcon;
